import { ShopifyVariant } from '@/lib/shopify';
import { memo } from 'react';

export interface OfferSchemaProps {
  variant: ShopifyVariant;
  url: string;
}

const OfferSchema = ({ variant, url }: OfferSchemaProps) => {
  const availability = variant.availableForSale
    ? 'http://schema.org/InStock'
    : 'http://schema.org/OutOfStock';

  return (
    <>
      <meta itemProp="price" content={variant.price?.amount?.toString()} />
      <meta itemProp="priceCurrency" content={variant.price?.currencyCode} />
      <meta itemProp="url" content={url} />
      <link itemProp="availability" href={availability} />
    </>
  );
};

export default memo(OfferSchema);
